// extracted by mini-css-extract-plugin
export default {"customDivider":"Product_customDivider__uozgo"};